import { KYC_DOC_TYPES, INPUT_TYPE } from "../../../config/const";
import React from "react";
import { Form, Row } from "react-bootstrap";

export const FORM_TYPE = {
  Create: "create",
  Update: "update",
};

const KycForm = ({
  handleChange,
  formError = {},
  selectedDocType = KYC_DOC_TYPES[0],
  setSelectedDocType,
  formType = FORM_TYPE.Create,
}) => {
  return (
    <Form>
      <Row>
        {formType === FORM_TYPE.Create && (
          <Form.Group className="form-group mb-4" controlId="formGroupAmount">
            <Form.Label>Select document type</Form.Label>
            <Form.Select
              name="type"
              onChange={(e) => {
                setSelectedDocType(
                  KYC_DOC_TYPES.find((f) => f.key === e.target.value)
                );
                handleChange(e);
              }}
              isInvalid={!!formError.type}
            >
              {/* <option>Select document view</option> */}
              {KYC_DOC_TYPES.map((type, idx) => {
                return (
                  <option key={idx} value={type.key}>
                    {type.name}
                  </option>
                );
              })}
            </Form.Select>

            <Form.Control.Feedback type="invalid">
              {formError?.type}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        {(selectedDocType.requiredDocId && (
          <Form.Group className="form-group mb-4" controlId="formGroupAmount">
            <Form.Label>Document ID*</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter document ID"
              name="documentId"
              onChange={(e) => handleChange(e)}
            />
          </Form.Group>
        )) ||
          null}
        <Form.Group className="form-group mb-4" controlId="formGroupAmount">
          <Form.Label>Front side file*</Form.Label>
          <Form.Control
            type="file"
            placeholder="File"
            name="documentFileFront"
            onChange={(e) => handleChange(e, INPUT_TYPE.FILE)}
            isInvalid={!!formError.documentFileFront}
          />

          <Form.Control.Feedback type="invalid">
            {formError?.documentFileFront}
          </Form.Control.Feedback>
        </Form.Group>
        {selectedDocType.requiredBackSide && (
          <Form.Group className="form-group mb-4" controlId="formGroupAmount">
            <Form.Label>Back side file*</Form.Label>
            <Form.Control
              type="file"
              placeholder="File"
              name="documentFileBack"
              onChange={(e) => handleChange(e, INPUT_TYPE.FILE)}
              isInvalid={!!formError.documentFileBack}
            />

            <Form.Control.Feedback type="invalid">
              {formError?.documentFileBack}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        <Form.Group className="form-group mb-4" controlId="formGroupAmount">
          <Form.Label>Expiry*</Form.Label>
          <Form.Control
            aria-label="Text input with dropdown button"
            onChange={(e) => handleChange(e, INPUT_TYPE.DATE)}
            type="date"
            name="expiry"
            min={new Date().toISOString().split("T")[0]}
            isInvalid={!!formError.expiry}
          />

          <Form.Control.Feedback type="invalid">
            {formError?.expiry}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </Form>
  );
};
export default KycForm;
